import { useEffect, useContext } from "react";
import { useQuery } from "@apollo/client/react";

import getApolloErrors from "helpers/getApolloErrors";
import showError from "helpers/showError";
import apolloClient from "helpers/apolloClient";
import { initContext } from "contexts";

import useProgressBar from "./useProgressBar";

export default function useData(
  query,
  variables,
  { returnMeta = false, progressBarOptions = {}, ...options } = {},
) {
  const inited = useContext(initContext);
  const { data, loading, error, refetch, fetchMore } = useQuery(query, {
    variables,
    client: apolloClient,
    fetchPolicy: "cache-and-network",
    errorPolicy: "none",
    partialRefetch: true,
    ...options,
    skip: !inited || options.skip,
  });

  useProgressBar(loading, { unobstrusive: true, ...progressBarOptions });

  useEffect(() => {
    if (error) {
      // Shown to the user only; server-side failures are already reported
      // to Rollbar by the API.
      for (const subError of getApolloErrors(error)) {
        if (["Observable cancelled prematurely"].includes(subError.message))
          continue;
        showError(subError);
      }
    }
  }, [error]);

  return returnMeta ? [data, { refetch, loading, fetchMore }] : data;
}
